import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle } from 'lucide-react';
const bonuses = [{
  title: "52 ÉCHAUFFEMENTS PRÊTS À L'EMPLOI",
  image: 'https://cdn.magicpatterns.com/uploads/i8zofU7vdFDb6t6eocLQdy/B-_1.webp',
  lines: ['52 échauffements de football complets.', "Un pour chaque semaine de l'année.", 'Des échauffements variés pour préparer vos joueurs avant chaque séance, toute l’année.']
}, {
  title: 'COLLECTION DE 100 JEUX DE FOOTBALL',
  image: 'https://cdn.magicpatterns.com/uploads/bTER86xPiSyqtmNqV1dWUi/B_-_2.webp',
  lines: ["100 jeux de football engageants, prêts à l'emploi.", 'Plaisir. Compétition. Développement.', 'Une bibliothèque de jeux pour rendre chaque entraînement plus motivant, à tout âge et à tout niveau.']
}, {
  title: "PACK D'ENTRAÎNEMENT D'URGENCE",
  image: 'https://cdn.magicpatterns.com/uploads/qLAyUBLv1uxH7cs7L5wZf6/B_-_3.webp',
  lines: ['30 séances immédiates pour :', 'Jours de pluie', 'Faible participation', 'Entraînement en intérieur', 'Espaces réduits', "Des séances de secours prêtes à l'emploi pour ne jamais annuler un entraînement."]
}, {
  title: "MANUEL DES COMMANDES DE L'ENTRAÎNEUR DE FOOTBALL",
  image: 'https://cdn.magicpatterns.com/uploads/cK8fqJcsq4JU38tn4c36qU/B_-_4.webp',
  lines: ["Plus de 100 commandes d'entraînement pour les séances et les jours de match.", 'Sachez quoi dire.', 'Sachez quand le dire.', 'Les phrases exactes pour mieux communiquer avec vos joueurs à l’entraînement et en match.']
}, {
  title: "SYSTÈME D'ÉVALUATION DES JOUEURS",
  image: 'https://cdn.magicpatterns.com/uploads/iE2uLDnzNmSoXqSi24xBKs/B_-_5.webp',
  lines: ["Des outils professionnels d'évaluation des joueurs.", 'Suivez les progrès. Créez des rapports. Construisez des plans de développement.', 'Des grilles simples pour suivre la progression de chaque joueur tout au long de la saison.']
}];
export function Bonuses() {
  return <section className="py-24 bg-navy-900 relative border-y border-navy-800" data-id="element-15" data-mp="3hk3zcpv2kkqc">
      <div className="container mx-auto px-4 relative z-10" data-id="element-16" data-mp="3lk4de9e9atwv">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-17" data-mp="3qj7i1sqbqy4b">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-500/20 text-gold-500 mb-6" data-id="element-18" data-mp="3qgl9pqvm0el1">
            <Gift className="w-8 h-8" data-id="element-19" data-mp="37lo88mw1lbgu" />
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-6xl text-white uppercase tracking-wide mb-6" data-id="element-20" data-mp="2a3o6j4grpllm">
5 BONUS INCLUS
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-300" data-id="element-21" data-mp="1xk8z9dbef461">
            Et vous recevrez aussi 5 bonus premium.
            <br data-id="element-22" data-mp="1eszn0wa8u1ar" />
            Des ressources d'entraînement exclusives qui vont transformer votre
            façon de travailler —{' '}
            <span className="text-green-400 font-bold" data-id="element-23" data-mp="15uxiw7v7qsj9">
              incluses GRATUITEMENT aujourd'hui.
            </span>
          </motion.p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6" data-id="element-24" data-mp="10xxc1uqjhlr3">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-950 border border-navy-700 rounded-xl p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center relative overflow-hidden" data-id="element-25" data-mp="3106mfjhdzqak" data-mpi={index}>
              <div className="absolute left-0 top-0 bottom-0 w-2 bg-gradient-to-b from-gold-400 to-gold-600" data-id="element-26" data-mp="28aznije0syos"></div>

              <div className="flex-shrink-0 w-full md:w-44 lg:w-52 relative group" data-id="element-27" data-mp="2daccpasd6huj">
                <div className="absolute -inset-2 bg-gold-500/10 blur-xl rounded-lg opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-28" data-mp="6ijt9qudowex"></div>
                <img src={bonus.image} alt={`Bonus ${index + 1} — ${bonus.title}`} loading="lazy" decoding="async" className="relative w-full h-auto rounded-lg shadow-2xl border border-navy-700/50" data-id="element-29" data-mp="lkjwc9mja0mt" />
                <div className="absolute top-2 left-2 bg-gold-500 text-navy-950 font-anton text-sm px-2.5 py-1 rounded-md shadow-lg" data-id="element-30" data-mp="plvexv6zplli">
                  #{index + 1}
                </div>
              </div>

              <div className="flex-grow" data-id="element-31" data-mp="zczsqrkxj0er">
                <div className="text-gold-500 font-oswald text-sm tracking-widest mb-1" data-id="element-32" data-mp="zbyfcggfy1tv">
                  BONUS #{index + 1}
                </div>
                <h3 className="font-oswald text-2xl text-white uppercase tracking-wide mb-4" data-id="element-33" data-mp="199uudjci1gx9">
                  {bonus.title}
                </h3>
                <ul className="space-y-2" data-id="element-34" data-mp="3f3mcoczd9wd7">
                  {bonus.lines.map((line, i) => <li key={i} className="flex items-start gap-2 text-gray-400" data-id="element-35" data-mp="3b3kb03tmt2xx" data-mpi={i}>
                      <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-36" data-mp="1izocjqtqmgie" />
                      <span data-id="element-37" data-mp="1nzkfrnum23ww">{line}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center bg-navy-800/50 border border-navy-700 rounded-xl p-8 max-w-3xl mx-auto" data-id="element-38" data-mp="1sw152ldjqobk">
          <h4 className="font-oswald text-2xl text-white uppercase tracking-widest mb-2" data-id="element-39" data-mp="2bnu16onwwpni">
            Tout ce qui est inclus dans
          </h4>
          <h3 className="font-anton text-3xl md:text-4xl text-gold-500 uppercase tracking-wide mb-4" data-id="element-40" data-mp="2gm59guyk6s3m">
            FOOTBALL PRÊT : SYSTÈME 365
          </h3>
          <p className="text-green-400 font-bold text-lg" data-id="element-41" data-mp="92zqpw38xc5x">
            Les 5 bonus sont inclus GRATUITEMENT avec votre achat aujourd'hui.
          </p>
        </motion.div>
      </div>
    </section>;
}